import React from "react";

import { USER_MANUAL } from "../../constants/user-manual.constants";
import Card from "../../common/card/card";

import "./getting-started-menu.component.scss"

const { HOME_PAGE, SIGN_IN, PRODUCT_PAGE, API_CARD_SECTION, ACCOUNT_AUTHORIZATION, USING_OTHER_API, USER_PROFILE_PAGE, SIGN_OUT, FORGOT_PASSWORD,POINT_TO_REMEMBER , ACTIVE } = USER_MANUAL

const GettingStartedMenu = ({ setActiveSummary, activeSummary }) => {

  const handleClick = (section) => {
    setActiveSummary(section);
  };

  return (
    <>
      <Card cardClass="list-card">
        <div className="py-6">
          <h3 className="-my-3 flow-root">
            <div
              className="flex w-full items-center justify-between  py-3 text-sm text-gray-400 hover:text-gray-500"
              aria-controls="filter-section-1"
              aria-expanded="false"
            ></div>
          </h3>

          <div className="pt-2" id="filter-section-1">
            <ul className="tree">
              <li>
                <summary onClick={() => handleClick(HOME_PAGE)} className={activeSummary === HOME_PAGE ? ACTIVE : ''} >Home Page</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(SIGN_IN)} className={activeSummary === SIGN_IN ? ACTIVE : ''}>Sign In Page</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(PRODUCT_PAGE)} className={activeSummary === PRODUCT_PAGE ? ACTIVE : ''} >Products Dashboard Page </summary>
              </li>
              <li>
                <summary onClick={() => handleClick(API_CARD_SECTION)} className={activeSummary === API_CARD_SECTION ? ACTIVE : ''} >APIs Card Section </summary>
              </li>
              <li>
                <summary onClick={() => handleClick(ACCOUNT_AUTHORIZATION)} className={activeSummary === ACCOUNT_AUTHORIZATION ? ACTIVE : ''} >Account Authorization</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(USING_OTHER_API)} className={activeSummary === USING_OTHER_API ? ACTIVE : ''} >Using the other APIs</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(USER_PROFILE_PAGE)} className={activeSummary === USER_PROFILE_PAGE ? ACTIVE : ''} >User Profile Page</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(SIGN_OUT)} className={activeSummary === SIGN_OUT ? ACTIVE : ''}  >Sign Out</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(FORGOT_PASSWORD)} className={activeSummary === FORGOT_PASSWORD ? ACTIVE : ''} >Forgot Password</summary>
              </li>
              <li>
                <summary onClick={() => handleClick(POINT_TO_REMEMBER)} className={activeSummary === POINT_TO_REMEMBER ? ACTIVE : ''} >Points to remember</summary>
              </li>

            </ul>
          </div>
        </div>
      </Card>

    </>
  )
}

export default GettingStartedMenu
